import React, { useEffect, useState } from "react";
import { closelightbox } from "../../../util/Functions";
import DayPickerInput from "react-day-picker/DayPickerInput";
import * as FORMAT from "react-day-picker/moment";
import * as API from "../../../http/api";
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";

import { ModalStyle } from "../../../util/Styles";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from "@albo-ui/core";
import { MenuItem, Select, TextField, Grid } from "@mui/material";

const ContraCargoNacionales = (props) => {
    const sectionOptions = [
        {"id":"41","input":false,"text":"41 TRANSACCIÓN RECURRENTE CANCELADA O NO SOLICITADA"},
        {"id":"75","input":false,"text":"75 AUTORIZACIÓN FALSA"},
        {"id":"57","input":false,"text":"57 TRANSACCIÓN MÚLTIPLE NO AUTORIZADA POR EL T.H"},
        {"id":"76","input":false,"text":"76 PEAJE / TAG"},
        {"id":"60","input":false,"text":"60 ORIGINAL O COPIA RECIBIDA ILEGIBLE O CON DATOS INCOM."},
        {"id":"79","input":false,"text":"79 COPIA U ORIGINAL DE PAGARE SOLICITADO NO RECIBIDO"},
        {"id":"63","input":false,"text":"63 CHIP (EMV)"},
        {"id":"80","input":false,"text":"80 ERROR EN PROCESO"},
        {"id":"64","input":false,"text":"64 TRANSACCIÓN MANUAL EN TERMINAL ELECTRÓNICA"},
        {"id":"82","input":false,"text":"84 FALTA DE FIRMA Y/O FIRMA EN ARCHIVO"},
        {"id":"68","input":false,"text":"68 TRANS. DE ORDEN TELEF/CORREO/INTERNET FRAUDULENTA"},
        {"id":"84","input":false,"text":"82 PROCESO DUPLICADO O MÚLTIPLE"},
        {"id":"70","input":false,"text":"70 TARJETA BOLETINADA"},
        {"id":"85","input":false,"text":"85 VENTA FRUSTRADA / DEVOLUCIÓN NO PROCESADA"},
        {"id":"71","input":false,"text":"71 AUTORIZACIÓN DECLINADA"},
        {"id":"86","input":false,"text":"86 ALTERACIÓN DEL IMPORTE"},
        {"id":"72","input":false,"text":"72 TRANS. EXCEDE EL IMPORTE AUTORIZADO O FALTA DE AUT."},
        {"id":"92","input":false,"text":"92 RECEPTOR DE PAGOS CON ACTIVIDAD IRREGULAR"},
        {"id":"74","input":false,"text":"74 PRESENTACIÓN EXTEMPORANEA"},
        {"id":"94","input":false,"text":"94 CAN. DE RESERV. GARANTIZADA, CARGOS DEMORADOS Y/O PAGO POR OTROS MEDIOS"},
    ];

    const [textReason, setTextReason] = useState("");
    const [optionsReason, setCheckReason] = useState("");
    const [disabled, setDisabled] = useState(true);

    const [comentarios, setComentarios] = useState("");
    const [dateConcepto, setDateConcepto] = useState("");
    const [selectedOption, setDelectedOption] = useState(0);

    const [checks, setChecks] = useState([]);
    const [option, setOpt] = useState([]);
    const [zPos, setZPos] = useState("initial");

    const handleOptions = (event) => {
        var value = Number(event.target.value);
        setDelectedOption(value);
        value !== 1 ? setDisabled(false) : setDisabled(true);
    };

    const handleDate = (event) => {
        var value = event.toJSON().substring(0, 10);
        setDateConcepto(value);
    };

    const handleSectionReason = (event) => {
        var value = event.target.value;
        event.target.checked ? setCheckReason(value) : setCheckReason("");
        setDisabled(false);
    };

    const handleSectionOption = (event) => {
        const value = event.target.value;
        const foundOption = sectionOptions.find((data) => data.id === value);

        if (foundOption) {
            setChecks([...checks, { check: value, option: value }]);
            setOpt([...option, value]);
            setDisabled(false);
        }
    };

    const descarga = async () => {
        props.changeLoader(true);
        setZPos("hidden");

        var data = {
            type: "anexo-8",
            content: {
                info: {
                    from: "Inteligencia en Finanzas, S.A.P.I. de C.V., IFPE (albo)",
                    to: props.data.concept,
                    accountNumber: props.data.panMasked,
                    reference: props.data.walletID,
                    amount: props.data.amount.toString(),
                },
                concept: {
                    first: selectedOption === 1 ? true : false,
                    rep: selectedOption === 2 ? true : false,
                    second: selectedOption === 3 ? true : false,
                    firstDate: selectedOption === 1 ? dateConcepto : "",
                    repDate: selectedOption === 2 ? dateConcepto : "",
                    secondDate: selectedOption === 3 ? dateConcepto : "",
                },
                reasonFirst: checks,
                reasonRep: {
                    reasonCode: selectedOption === 2 ? textReason : "",
                    check: optionsReason,
                    option: optionsReason,
                },
                reasonSecond: {
                    code: selectedOption === 3 ? textReason : "",
                },
                comments: comentarios,
            },
            url: "signed",
            agent_uuid: "",
        };

        let request = await API.service("cartasDocs", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200) {
            if (request.data.data.response === "OK") {
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, "success", "Carta contra cargos creada con éxito");
                window.open(dataResult, "_blank");
            } else {
                props.changeAlert(true, "error", "Error al crear carta de contra cargos.");
            }
        }
        setZPos("initial");
        closelightbox();
        props.changeLoader(false);
    };

    useEffect(() => {
        reset();
    },[])
    
    const reset = () => {
        setTextReason("");
        setCheckReason("");
        setDisabled(true);
        setComentarios("");
        setDateConcepto("");
        setDelectedOption(0);
        setChecks([]);
        setOpt([]);
    }

    return (
        <Dialog open={true} onClose={closelightbox} style={{visibility: zPos, minWidth: "80%", maxHeight: "500px"}}>
            <ModalStyle property={String(false)}>
                <DialogTitle>
                    <FlexGrid>
                        <Typography variant="h2">ANEXO 8</Typography>
                    </FlexGrid>
                    <FlexGrid>
                        <Typography variant="smallTitle" style={{ paddingTop: -15 }}>
                            DOCUMENTACIÓN TRANSMITIDA PARA CONTRACARGO, REPRESENTACIÓN O PREARBITRAJE
                        </Typography>
                    </FlexGrid>
                </DialogTitle>

                {props.data && (
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="paragraph">De: Inteligencia en Finanzas, S.A.P.I. de C.V., IFPE (albo)</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="paragraph">Para: {props.data.concept}</Typography>
                            </Grid>
                            <Grid item xs={6} pt={"5px !important"}>
                                <Typography variant="paragraph">Número de Tarjeta: {props.data.panMasked}</Typography>
                            </Grid>
                            <Grid item xs={6} pt={"5px !important"}>
                                <Typography variant="paragraph">Importe: {props.data.amountFormated}</Typography>
                            </Grid>
                            <Grid item xs={6} pt={"5px !important"}>
                                <Typography variant="paragraph">Referencia: {props.data.walletID}</Typography>
                            </Grid>
                        </Grid>

                        <Grid mt={3}>
                            <Typography variant="smallTitle">CONCEPTO</Typography>
                        </Grid>

                        <Grid container spacing={2} pt={1}>
                            <Grid item xs={6}>
                                <Select MenuProps={{ style: { zIndex: 35001 } }} defaultValue={0} onChange={handleOptions} color="secondary" size="small" fullWidth>
                                    <MenuItem value={0} disabled>Seleccione el concepto</MenuItem>
                                    <MenuItem value={1}>CONTRACARGO</MenuItem>
                                    <MenuItem value={2}>REPRESENTACIÓN</MenuItem>
                                    <MenuItem value={3}>PREARBITRAJE</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item xs={6}>
                                <DayPickerInput
                                    style={{ width: "100%" }}
                                    placeholder="Seleccione la fecha"
                                    format="DD-MM-YYYY"
                                    onDayChange={handleDate}
                                    inputProps={{readOnly: true, style: { height: 40 }}}
                                    formatDate={FORMAT.default.formatDate}
                                    parseDate={FORMAT.default.parseDate}
                                    dayPickerProps={{
                                        months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                        pagedNavigation: true,
                                        numberOfMonths: 1,
                                    }}
                                />
                            </Grid>
                        </Grid>

                        {selectedOption === 1 && (
                            <>
                                <Grid mt={4}>
                                    <Typography variant="smallTitle">
                                        RAZONES PARA CONTRACARGO
                                    </Typography>
                                </Grid>
                                <Grid container spacing={2} pt={2}>
                                    {sectionOptions.map((item) => {
                                        return (
                                            <Grid item xs={6} key={item.id}>
                                                <input type="checkbox" onChange={handleSectionOption.bind(this)} value={item.id} style={{ marginRight: 20 }}/>
                                                {item.text}
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                                <Grid mt={4}>
                                    <Typography variant="smallTitle" style={{ fontWeight: 500 }}>
                                        OPCIÓN(ES): {option.sort().join(", ")}
                                    </Typography>
                                </Grid>
                            </>
                        )}
                        {selectedOption === 2 && (
                            <>
                                <Grid mt={4}>
                                    <Typography variant="smallTitle">
                                        RAZÓN PARA REPRESENTACIÓN
                                    </Typography>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        Código de razón del contracargo:{" "}
                                        <input type="text" onChange={(e) => {setTextReason(e.target.value)}} style={{ width: "15%" }} className="ibon-account"/>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <input type="checkbox" value="99" onChange={handleSectionReason} style={{ marginRight: 20 }}/>
                                        99 VARIOS
                                    </Grid>
                                </Grid>
                            </>
                        )}
                        {selectedOption === 3 && (
                            <>
                                <Grid mt={4}>
                                    <Typography variant="smallTitle">RAZÓN DE PREARBITRAJE</Typography>
                                </Grid>
                                <Typography variant="paragraph">
                                    Opción de representación usada por el adquiriente:{" "}
                                    <input type="text" style={{ width: "10%" }} onChange={(e) => {setTextReason(e.target.value)}}/>
                                </Typography>
                            </>
                        )}

                        <Grid item mt={4}>
                            <Typography variant="smallTitle">COMENTARIOS:</Typography>
                        </Grid>
                        <Grid item container pt={1}>
                            <TextField fullWidth multiline minRows={4} onChange={(e) => {setComentarios(e.target.value)}}/>
                        </Grid>
                    </DialogContent>
                )}

                <DialogActions>
                    <FlexGrid fullWidth fullHeight justify="space-between" alignItems="space-between" style={{ marginTop: "20px", display: "flex" }}>
                        <FlexGrid item>
                            <Button onClick={closelightbox} buttonType="secondary" size="normal">
                                Cancelar
                            </Button>
                        </FlexGrid>
                        <FlexGrid item style={{ textAlign: "end" }}>
                            <Button onClick={descarga} disabled={disabled} size="normal">
                                Descargar
                            </Button>
                        </FlexGrid>
                    </FlexGrid>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default ContraCargoNacionales;
